import { Component, ViewEncapsulation, OnInit, TemplateRef, ElementRef, HostListener } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../environments/environment';
import { Title, Meta } from '@angular/platform-browser';
import { IndexService } from '../_Service/Index/index.service';
import { ChatService } from '../_Service/Chat/chat.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { SigninSignUpService } from '../_Service/UsersSignInSignUp/signin-sign-up.service';
import { EditProfileService } from '../_Service/EditProfile/edit-profile.service';
import { UserConnectionService } from '../_Service/UserConnection/user-connection.service';
import * as moment from 'moment-timezone';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./news-detail.component.css']
})
export class NewsDetailComponent implements OnInit {
  title: any;
  title_url: any;
  platform_name: any;
  platform_logo: any;
  platform_id: any;
  project_url: any;
  newsDetailsArr: any;
  news_id: any;
  news_key: any = '';
  // title: any;
  timezone: any;
  videoPlayButton: any;
  newsDetailsLoader: boolean;
  meta_logo: any;
  mostViewedNewsArr: any;
  mostViewNewsLoader: boolean = true;
  leagueLoader: boolean = true;
  emptyNewsDetails: boolean;

  pals_bg: any;

  description: any;

  leagueList: any;

  share_icon: any;
  modalRef: BsModalRef;
  modalRefList: BsModalRef;


  //Post Share Variable(n)
  sharePostArr: any;
  showHideSharePost: any;
  postButtonHide: any;

  showHideSharePostSocialMediaConservative: any;
  showHideSharePostSocialMediaTwitter: any;
  showHideSharePostSocialMediaFacebook: any;
  showHideSharePostSocialMediaLinkedin: any;

  mediaPostTextTemp: any;

  //Get contact list for send messaage(n)
  UserchatForwardDetailsLoader: any;
  connectchatForwardUserListArr: any;
  UserDetailschatForwardLoaderFirstTime: any;
  showMorechatForwardUserConnectList: any;
  nextPagechatForwardConnectUserList: any;
  contactForForwardSearch: any;

  user_details: any;
  user_profile_img: any;

  aliasNameBlank: any;
  alias_mode_name: string;
  isDropup = true;

  // multiselect veriables (p)
  leagueListAllTeams = [];
  selectedLeagueAllTeams = [];
  leagueDropdownSettingsAllTeams = {};

  leagueListAllPlayers = [];
  selectedLeagueAllPlayers = [];
  leagueDropdownSettingsAllPlayers = {};

  teamListAllPlayers = [];
  selectedTeamAllPlayers = [];
  teamDropdownSettingsAllPlayers = {};

  // multiselect veriables end(p)
  showMore: boolean = false;
  showPosts: boolean = true;
  lineLoader: boolean = false;
  userId: any;
  primaryLoaderConatct: boolean = false;
  getContactNameArr: any = [];
  //showMoreUserList: boolean = false;
  showMoreUserList: any;
  nextPageFollow: any;
  profileType: any;
  searchFollowList: any;
  message: any;
  league_news: any;
  searchSport: any = '';
  searchTeam: any = '';
  searchPlayer: any = '';
  showMoreSport: boolean = false;
  showMoreTeam: boolean = false;
  showMorePlayer: boolean = false;
  nextPage: any;
  news_league_id: any;
  login_user_type: any;
  tab: any = 'tab1';
  tab1: any
  tab2: any
  tab3: any
  tab4: any
  Clicked: boolean
  currentTab: any;
  PostSendType: any;
  addPostArr: any;


  // All variable for show 2000 character message(D)
  totalStringLength: any;
  totalMaxLength: number = 2000;
  urlStringLength: number;

  tooltipText: string = "Share News on your timeline / with fans / on message chat";
  isMobileDevice: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileDevice = window.innerWidth <= 768; //true
    this.updateTooltipText();
  }
  // Close the pop modal on back button click (D)
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }
  // Close the pop modal on back button click (D)

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private modalService: BsModalService,
    private _IndexService: IndexService,
    private route: Router,
    private paramsroutes: ActivatedRoute,
    private _SigninSignUp: SigninSignUpService,
    private _ChatService: ChatService,
    private _EditProfileService: EditProfileService,
    private _UserConnectionService: UserConnectionService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private _signInsignUp: SigninSignUpService,
    private elementRef: ElementRef) {

    this.platform_name = environment.platform_name;
    this.platform_logo = environment.platform_logo;
    this.meta_logo = environment.blog_img;
    this.platform_id = environment.platform_id;
    this.project_url = environment.project_url;

    this.pals_bg = environment.pals_bg;
    this.share_icon = environment.share_icon;
    this.user_profile_img = environment.user_profile_img;
    this.alias_mode_name = environment.alias_mode_name;

    //End of Setting the title and meta tag of component page
    this.timezone = ''
    // this.news_key = this.decryptData(localStorage.getItem('news_id'));
    this.newsDetailsLoader = true;
    this.emptyNewsDetails = false;
    this.mostViewedNewsArr = [];
    this.mostViewNewsLoader = true;
    this.videoPlayButton = 0;
    this.PostSendType = [];
    this.addPostArr = [];
    this.addPostArr.privacyType = 1;
    this.addPostArr.iconClassnName = 'mdi-earth text-primary';

    if (localStorage.getItem('geoDetails')) {
      let res = JSON.parse(this.decryptData(localStorage.getItem('geoDetails')));
      if (res && res['geo'] && res['geo']['timezone']) {
        this.timezone = res['geo']['timezone'];
        //geting the blog id (D)

        if (this.paramsroutes.snapshot.params && this.paramsroutes.snapshot.params['lable']) {
        

          this.title_url = '';

          if (this.paramsroutes.snapshot.params['lable']) {
            this.title_url = this.paramsroutes.snapshot.params['lable'];


            if (localStorage.getItem("token") && localStorage.getItem("token") != '') {
              true;
            } else {
              this.route.navigateByUrl('/news/' + this.title_url);
            }

            let mostViewBlog =
            {
              platform_id: this.platform_id,
              search: '',
              page: ''
            }
            this._SigninSignUp.getNewsDetailsBreaking(mostViewBlog).subscribe(res => {
              if (res && res['status_code'] == 200) {
                for (let i = 0; i < res['breaking_news'].length; i++) {
                  res['breaking_news'][i]['url'] = this.project_url + 'news/' + res['breaking_news'][i]['title_url'];
                  if (i + 1 == res['breaking_news'].length) {
                    this.mostViewedNewsArr = res['breaking_news'];
                    this.mostViewNewsLoader = false;
                  }
                }
              } else {
                this.toastr.error(res['message'], 'Error!');
              }
              this.getDetailsofnews();
            });
          }
        }
      }

    }

    this._IndexService.getPrivacySettings().subscribe(
      res => {
        if (res && res['privacy_settings']) {
          this.PostSendType = res['privacy_settings'];
        }
      }
    );
  }

  ngOnInit() {
    this.isMobileDevice = window.innerWidth <= 768;
    this.updateTooltipText();
    //Post Share Variable(n)
    this.sharePostArr = {};
    this.login_user_type = 1;
    this.sharePostArr.commentShareConservative = 'Conservative';
    this.sharePostArr.commentShareConservativeSection = 'tab1';
    this.postButtonHide = true;

    //Get contact list for send messaage(n)
    this.UserchatForwardDetailsLoader = false;
    this.UserDetailschatForwardLoaderFirstTime = true;
    this.connectchatForwardUserListArr = [];
    this.contactForForwardSearch = '';
    //Get Login User MyProfile Details(n)
    this._EditProfileService.getLoginUserMyProfileDetails().subscribe(
      res => {
        if (res && res['status_code'] == 200) {
          if (res && res['user_details']) {
            this.user_details = res['user_details'];
            //set the local variable if alias name is blank on login(D)
            if (res && res['user_details'] && res['user_details']['alias_name'] == "") {
              this.aliasNameBlank = true;
            } else {
              this.aliasNameBlank = false;
            }
            //set the local variable if alias name is blank on login(D)
          }
          this.getNewsDetailsCount();
        } else if (res && res['status_code'] == 401) {
          this.toastr.error(res['messgae'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        } else {
          this.toastr.error('Something went wrong.', 'Error!');
        }
      });

  }
  updateTooltipText() {
    this.tooltipText = this.isMobileDevice ? "Share News" : "Share News on your timeline / with fans / on message chat";
  }

  //Set Privacy Settings Button click funtion(n)
  SetPrivacySettingsBtn(privacy_type, icon_class_name) {
    this.addPostArr.privacyType = privacy_type;
    this.addPostArr.iconClassnName = icon_class_name;
  }
  //End Set Privacy Settings Button click funtion(n)

  removeTags(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, '');
  }

  getDetailsofnews() {
    let newsDetails =
    {
      news_title: this.title_url
    }

    this.newsDetailsArr = [];
    this.newsDetailsLoader = true;
    this._IndexService.getNewsDetailsByTitle(newsDetails).subscribe(
      res => {
        if (res && res['status_code'] && res['status_code'] == 200) {
          if (res && res['news_details']) {
            res['news_details']['url'] = this.project_url + 'news/' + res['news_details']['title_url'];

            res['news_details']['url_share'] = this.project_url + 'news/' + res['news_details']['title_url'];

            this.newsDetailsArr = res['news_details'];
            if (res['news_details'] && res['news_details']['publishedAt'] && res['news_details']['publishedAt'] != '0000-00-00 00:00:00') {
              let created_at = moment(res['news_details']['publishedAt']).tz(this.timezone);
              let created_date = this.datePipe.transform(created_at, "dd MMM, yyyy");
              let created_time = this.datePipe.transform(created_at, "hh:mm a");
              res['news_details']['posted_time'] = created_date + ' at ' + created_time;
            }

            //Setting the title and meta tag of component page(D)
            if (this.newsDetailsArr['title']) {
              this.title = this.newsDetailsArr['title'].substring(0, 100);
            } else {
              if (this.newsDetailsArr['img_headline']) {
                this.title = this.newsDetailsArr['img_headline'].substring(0, 100);
              } else {
                this.title = '';
              }
            }

            if (this.newsDetailsArr['content']) {
              this.description = this.removeTags(this.newsDetailsArr['content']).substring(0, 160);
            } else {
              if (this.newsDetailsArr['caption']) {
                this.description = this.removeTags(this.newsDetailsArr['caption']).substring(0, 160);
              } else {
                this.description = '';
              }
            }

            this.titleService.setTitle(this.title);
            this.metaTagService.addTag({ name: 'keywords', content: this.title });
            this.metaTagService.addTag({ name: 'description', content: this.description });

            this.metaTagService.addTag({ name: 'robots', content: 'all' });

            this.metaTagService.addTag({ property: 'og:locale', content: 'en_US' });
            this.metaTagService.addTag({ property: 'og:card', content: 'summary_large_image' });
            this.metaTagService.addTag({ property: 'og:site_name', content: this.platform_name });
            this.metaTagService.addTag({ property: 'og:title', content: this.title });
            this.metaTagService.addTag({ property: 'og:description', content: this.description });
            this.metaTagService.addTag({ property: 'og:url', content: this.project_url + this.route.url });
            this.metaTagService.addTag({ property: 'og:image:width', content: '1200' });
            this.metaTagService.addTag({ property: 'og:image:height', content: '630' });
            this.metaTagService.addTag({ property: 'og:image:alt', content: this.description });

            this.metaTagService.addTag({ name: 'twitter:card', content: 'summary_large_image' });
            this.metaTagService.addTag({ name: 'twitter:site_name', content: this.platform_name });
            this.metaTagService.addTag({ name: 'twitter:title', content: this.title });
            this.metaTagService.addTag({ name: 'twitter:description', content: this.description });
            this.metaTagService.addTag({ name: 'twitter:url', content: this.project_url + this.route.url });
            this.metaTagService.addTag({ name: 'twitter:image:width', content: '800' });
            this.metaTagService.addTag({ name: 'twitter:image:height', content: '480' });
            this.metaTagService.addTag({ name: 'twitter:image:alt', content: this.description });


            if (this.newsDetailsArr['urlToImage'] && this.newsDetailsArr['urlToImage'] != "") {
              this.metaTagService.addTag({ property: 'og:image', content: this.newsDetailsArr['urlToImage'] });
              this.metaTagService.addTag({ name: 'twitter:image', content: this.newsDetailsArr['urlToImage'] });

            } else if (this.newsDetailsArr['profile_pic'] && this.newsDetailsArr['profile_pic'] != "") {
              if (this.newsDetailsArr['profile_pic']) {
                this.metaTagService.addTag({ property: 'og:image', content: this.newsDetailsArr['profile_pic'] });
                this.metaTagService.addTag({ name: 'twitter:image', content: this.newsDetailsArr['profile_pic'] });
              } else {
                this.metaTagService.addTag({ property: 'og:image', content: this.project_url + '' + this.meta_logo });
                this.metaTagService.addTag({ name: 'twitter:image', content: this.project_url + '' + this.meta_logo });
              }
            } else {
              this.metaTagService.addTag({ property: 'og:image', content: this.project_url + '' + this.meta_logo });
              this.metaTagService.addTag({ name: 'twitter:image', content: this.project_url + '' + this.meta_logo });
            }
            //End Setting the title and meta tag of component page(D)
            if (this.timezone) {
              this.newsDetailsLoader = false;
            } else {
              this.newsDetailsLoader = true;
            }
          } else {
            this.newsDetailsLoader = false;
            this.emptyNewsDetails = true;
            // this.route.navigate(['/news']);  
          }
        } else {
          this.newsDetailsLoader = false;
          this.emptyNewsDetails = true;
          this.route.navigate(['/news']);
        }
      }, (err) => {
        this.newsDetailsLoader = false;
        this.emptyNewsDetails = true;
        if (err && err['message']) {
          this.route.navigate(['/news']);
        }
      });
  }
  //Encrypt Data(n)

  encryptData(data) {

    try {
      if (data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), '1234509876encryptdecrypt1234567890').toString();
      }
    } catch (e) {

    }
  }
  //End encrypt Data(n)

  //Decrypt Data (n)
  decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, '1234509876encryptdecrypt1234567890');
      if (bytes.toString()) {
        if (CryptoJS.enc.Utf8) {
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
      }
      if (data) {
        return data;
      }
    } catch (e) {
      this.route.navigate(['/news']);
    }
  }
  //End Decrypt Data (n)
  //Post Text With media upload(a)
  playVideo(event: any, pmId): void {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {

    } else {
      if (event && event.target && event.target.previousElementSibling) {
        //event.target.play();
        this.videoPlayButton = pmId;
        const playedPromise = event.target.previousElementSibling.play();
        if (playedPromise) {
          playedPromise.catch((e) => {
            if (e.name === 'NotAllowedError' ||
              e.name === 'NotSupportedError') {
            }
          });
        }
      }
    }
  }

  pauseVideo(event: any, pmId): void {
    if (event && event.target) {
      event.target.pause();
      this.videoPlayButton = 0;
    }
  }

  //Get the list of click on show more button (D)
  blogDetailsRedirct(blog) {
    if (blog.blog_title_url) {

      // this.route.navigateByUrl('/blog/' + encodeURIComponent(blog.title));
      this.route.navigateByUrl('/blog' + blog.blog_title_url);
    }
  }
  //Post View Detail click to redirect on details page(n)


  getNewsDetailsCount() {
    this._SigninSignUp.getNewsDetailsCount().subscribe(
      res => {
        this.leagueList = res["news_detail_count"];
        this.leagueList = this.leagueList.map((elem)=>{
          if(elem.name == "IPL"){
             elem.name = "Cricket";
          }
          return elem
        });
        this.leagueLoader = false;
      }, (err) => {

      }
    );
  }

  filterByLeague(league) {
    localStorage.setItem("league", this.encryptData(league));
    this.route.navigate(['/news']);
  }

  openModal(template: TemplateRef<any>, news) {
    //Social media share variable(n) 
    this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered' });

    this.addPostArr.privacyType = 1;
    this.addPostArr.iconClassnName = 'mdi-earth text-primary';


    this.showHideSharePostSocialMediaConservative = true;
    this.showHideSharePostSocialMediaTwitter = false;
    this.showHideSharePostSocialMediaFacebook = false;
    this.showHideSharePostSocialMediaLinkedin = false;
    //Social media share variable(n)

    //Post Share Variable(n)
    this.sharePostArr = {};
    this.sharePostArr.media_path = '';
    this.sharePostArr.media_mime_type = '';
    this.showHideSharePost = true;
    this.postButtonHide = true;

    this.sharePostArr.commentShareConservative = 'Conservative';
    this.sharePostArr.commentShareConservativeSection = 'tab1';


    this.sharePostArr.platform_id = this.platform_id;

    if (this.sharePostArr.commentShareConservativeSection == 'tab1') {
      this.sharePostArr.user_type = 1;
      this.sharePostArr.post_privacy = 1;
    } else {
      if (this.sharePostArr.commentShareConservativeSection == 'tab2') {
        this.sharePostArr.user_type = 1;
      } else {
        this.sharePostArr.user_type = 2;
      }
      this.sharePostArr.post_privacy = 2;
    }
    this.sharePostArr.sharePostTextMsg = '';
    this.sharePostArr.sharePostNewsId = news['id'];
    this.sharePostArr.sharePostNewsUrl = news['url_share'];

    let urlString = ' </br><a class="truncate_post_url" href="' + this.sharePostArr.sharePostNewsUrl + '" target="_blank">' + this.sharePostArr.sharePostNewsUrl + '</a>';
    this.urlStringLength = urlString.length;
    this.totalMaxLength = 2000 - this.urlStringLength;

    if (news['title']) {
      this.sharePostArr.sharePostText = news['title'].substring(0, 2000);
      let str_title = news['title'];
      this.sharePostArr.sharePostTextShow = (str_title.length > 100) ? str_title.substr(0, 100 - 1) + '...' : str_title;
    } else {
      this.sharePostArr.sharePostText = news['content'].substring(0, 2000);
      let str_title = news['content'];
      this.sharePostArr.sharePostTextShow = (str_title.length > 100) ? str_title.substr(0, 100 - 1) + '...' : str_title;
    }

    if (news['content']) {
      this.sharePostArr.sharePostDescription = news['content'].substring(0, 2000);
      let str_content = news['content'];
      this.sharePostArr.sharePostDescriptionShow = (str_content.length > 150) ? str_content.substr(0, 150 - 1) + '...' : str_content;

      // this.sharePostArr.sharePostDescriptionShow=blog['blog_content'].substring(0,100); 
    } else {
      this.sharePostArr.sharePostDescription = '';
      this.sharePostArr.sharePostDescriptionShow = '';
    }

    if (this.sharePostArr.sharePostText == '') {
      this.showHideSharePost = false;
    } else {
      this.urlifyPostOnlyLink(this.sharePostArr.sharePostText);
    }

    if (news.urlToImage) {
      let fileName = news.urlToImage;
      let extension = fileName.split('.').pop();

      this.sharePostArr.media_path = news.urlToImage;
      //   this.sharePostArr.media_mime_type = news.urlToImage;
      this.sharePostArr.media_mime_type = 'image/' + extension;
    } else {
      this.sharePostArr.media_path = '';
      this.sharePostArr.media_mime_type = '';
    }
  }

  openModalMessenger() {
    this.contactForForwardSearch = '';
    // this.getConnectedUsersList();

    this.contactSearch = '';
    this.selectAllUserOrFans('2');
  }


  //Add Post show url details variables(n)
  urlifyPostOnlyLink(event: any) {

    let text;
    if (event.isTrusted) { 		//This method is checking if event is inputType or event is only text(D)
      event.target.value = event.target.value.replace(/^\s+/g, "");
      text = event.target.value;
      this.sharePostArr.postText = text;
    } else {
      event = event.replace(/^\s+/g, "");
      text = event;
      this.sharePostArr.postText = text;
    }							//End This method is checking if event is inputType or event is only text(D)

    this.showHideSharePost = true;
    let urlRegex = /(([a-z]+:\/\/)?(([a-z0-9\-]+\.)+([a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel|local|internal))(:[0-9]{1,5})?(\/[a-zA-Z0-9_%\-\!\.~]+)*(\/([a-zA-Z0-9_%\-\!\.]*)(\?[a-zA-Z0-9+_\-\!\.%=&amp;]*)?)?(#[a-zA-Z0-9!$&'()*+.=!-_~:@/?]*)?)(\s+|$)/gi;


    this.mediaPostTextTemp = text.replace(urlRegex, function (url) {
      return '<a target=" _blank" href="' + url + '">' + url + '</a>';
    });
    this.mediaPostTextTemp = this.mediaPostTextTemp.replace(/^\s+/g, "");
    this.totalStringLength = this.mediaPostTextTemp.length + this.urlStringLength;
    if (this.totalStringLength > 1999) {
      let diff = 2000 - this.urlStringLength;
      this.mediaPostTextTemp = this.mediaPostTextTemp.slice(0, diff);
    } else {
      this.totalStringLength = this.mediaPostTextTemp.length + this.urlStringLength;
    }
  }

  getConnectedUsersList() {

    let searchNamePost = {
      search: '',
      page: ''
    }
    this.UserDetailschatForwardLoaderFirstTime = true;
    this.UserchatForwardDetailsLoader = true;
    this.connectchatForwardUserListArr = [];
    this._ChatService.getConnactUserListForChat(searchNamePost).subscribe(
      res => {
        this.UserDetailschatForwardLoaderFirstTime = false;
        this.UserchatForwardDetailsLoader = false;

        if (res && res['connect_user_list']) {
          for (let i = 0; i < res['connect_user_list'].length; i++) {
            this.connectchatForwardUserListArr = this.connectchatForwardUserListArr.filter(item => item.id != res['connect_user_list'][i].id);
            this.connectchatForwardUserListArr.push(res['connect_user_list'][i]);
          }
        }

        this.showMorechatForwardUserConnectList = res['showMore'];
        if (res && res['nextPage']) {
          this.nextPagechatForwardConnectUserList = res['nextPage'];
        }

      }, (err) => {
        this.UserDetailschatForwardLoaderFirstTime = false;
        this.UserchatForwardDetailsLoader = false;

        if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
          this.toastr.error(err['error']['message'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        }
      });
  }

  searchForwarModalUserList($event) {
    this.contactForForwardSearch = $event.target.value;
    let searchNamePost = {
      search: this.contactForForwardSearch,
      page: ''
    }
    this.UserDetailschatForwardLoaderFirstTime = false;
    this.UserchatForwardDetailsLoader = true;

    this._ChatService.getConnactUserListForChat(searchNamePost).subscribe(
      res => {
        this.UserDetailschatForwardLoaderFirstTime = false;
        this.UserchatForwardDetailsLoader = false;
        this.connectchatForwardUserListArr = [];

        if (res && res['connect_user_list']) {
          for (let i = 0; i < res['connect_user_list'].length; i++) {
            this.connectchatForwardUserListArr = this.connectchatForwardUserListArr.filter(item => item.id != res['connect_user_list'][i].id);
            this.connectchatForwardUserListArr.push(res['connect_user_list'][i]);
          }
        }

        this.showMorechatForwardUserConnectList = res['showMore'];
        if (res && res['nextPage']) {
          this.nextPagechatForwardConnectUserList = res['nextPage'];
        }

      }, (err) => {
        this.UserDetailschatForwardLoaderFirstTime = false;
        this.UserchatForwardDetailsLoader = false;

        if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
          this.toastr.error(err['error']['message'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        }
      });
  }

  showMorechatForwardUserListByName(nextPage) {
    if (nextPage) {
      let searchNamePost = {
        search: this.contactForForwardSearch,
        page: nextPage
      }
      this.UserDetailschatForwardLoaderFirstTime = false;
      this.UserchatForwardDetailsLoader = true;

      this._ChatService.getConnactUserListForChat(searchNamePost).subscribe(
        res => {
          this.UserDetailschatForwardLoaderFirstTime = false;
          this.UserchatForwardDetailsLoader = false;

          if (res && res['connect_user_list']) {
            for (let i = 0; i < res['connect_user_list'].length; i++) {
              this.connectchatForwardUserListArr = this.connectchatForwardUserListArr.filter(item => item.id != res['connect_user_list'][i].id);

              this.connectchatForwardUserListArr.push(res['connect_user_list'][i]);
            }
          }

          this.showMorechatForwardUserConnectList = res['showMore'];
          if (res && res['nextPage']) {
            this.nextPagechatForwardConnectUserList = res['nextPage'];
          }

        }, (err) => {
          this.UserDetailschatForwardLoaderFirstTime = false;
          this.UserchatForwardDetailsLoader = false;

          if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
            this.toastr.error(err['error']['message'], 'Error!');
            localStorage.clear();
            sessionStorage.removeItem('fullcomponent');
            this.route.navigate(['/login']);
          } 
        });
    }
  }

  clickedBtn: any = false;
  forwardMessageSendFun(sharePostArr, user) {

    this.clickedBtn = true;
    let postMessageData = {
      login_user_id: this.user_details.id,
      news_id: sharePostArr.sharePostNewsId,
      sharePostText: sharePostArr.sharePostTextMsg,
      chat_user_id: user.id,
      news_url: sharePostArr.sharePostNewsUrl,
      title: sharePostArr.sharePostText,
      news_des: sharePostArr.sharePostDescription,
      news_media_path: sharePostArr.media_path,
      news_media_mime_type: sharePostArr.media_mime_type,
      message: '',
      mime_type: '',
      type: 3
    }
    this._IndexService.newsAsMessageSend(postMessageData).subscribe(
      res => {
        this.clickedBtn = false;
        //push notification start
        const data = {
          user_id: user.id,
          type: 'Chat message',
          url: '/messageChat'
        }
        this._UserConnectionService.sendPushNotification(data);
        //push notification end

        // Socket(n)
        let socketData = {
          responce: postMessageData,
          type: 'message',
        };
        this._ChatService.sendMessageSocket(socketData);
        // Socket(n)
        this.toastr.success('News share in message successfully', 'Success!');
      }, (err) => {
        this.clickedBtn = false;
        if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
          this.toastr.error(err['error']['message'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        } 
      });
  }

  shareCheckBoxChangeSection(template, tab) {
    if (tab == 'tab3' && this.aliasNameBlank) {
      if (this.aliasNameBlank) {
        this.modalRef.hide();
        this.modalRef = this.modalService.show(template, { class: 'modal-md', backdrop: true, ignoreBackdropClick: true });
      } else {
        this.sharePostArr.user_type = 2;
        this.sharePostArr.post_privacy = 2;
      }
    } else {
      if (this.sharePostArr.commentShareConservativeSection == 'tab1') {
        this.sharePostArr.user_type = 1;
        this.sharePostArr.post_privacy = 1;
      } else {
        if (this.sharePostArr.commentShareConservativeSection == 'tab2') {
          this.sharePostArr.user_type = 1;
        } else {
          this.sharePostArr.user_type = 2;
        }
        this.sharePostArr.post_privacy = 2;
      }
    }
  }

  shareCheckBoxChange() {
    //Social media text share variable(n)
    if (this.sharePostArr.commentShareConservative && this.sharePostArr.commentShareConservative == 'Conservative') {
      this.showHideSharePostSocialMediaConservative = true;
      this.showHideSharePostSocialMediaTwitter = false;
      this.showHideSharePostSocialMediaFacebook = false;
      this.showHideSharePostSocialMediaLinkedin = false;

    } else if (this.sharePostArr.commentShareConservative && this.sharePostArr.commentShareConservative == 'Twitter') {

      this.showHideSharePostSocialMediaConservative = false;
      this.showHideSharePostSocialMediaTwitter = true;
      this.showHideSharePostSocialMediaFacebook = false;
      this.showHideSharePostSocialMediaLinkedin = false;

    } else if (this.sharePostArr.commentShareConservative && this.sharePostArr.commentShareConservative == 'Facebook') {
      this.showHideSharePostSocialMediaConservative = false;
      this.showHideSharePostSocialMediaTwitter = false;
      this.showHideSharePostSocialMediaFacebook = true;
      this.showHideSharePostSocialMediaLinkedin = false;

    } else if (this.sharePostArr.commentShareConservative && this.sharePostArr.commentShareConservative == 'Linkedin') {
      this.showHideSharePostSocialMediaConservative = false;
      this.showHideSharePostSocialMediaTwitter = false;
      this.showHideSharePostSocialMediaFacebook = false;
      this.showHideSharePostSocialMediaLinkedin = true;

    }
    //End Social media text share variable(n)
  }

  //Create Post button(n)
  CreatePostBtn() {
    if (this.totalStringLength <= 2000) {
      if (this.mediaPostTextTemp && this.mediaPostTextTemp != '') {
        this.sharePostArr.post_text = this.mediaPostTextTemp;
      } else {
        this.sharePostArr.post_text = this.sharePostArr.sharePostText;
      }
      this.sharePostArr.post_text = this.sharePostArr.post_text.replace(/ ?#(\w+)/gi, '<a href="/userSearch/$1"> #$1</a>');

      if (this.sharePostArr.post_text != "") {
        this.sharePostArr.post_text = this.sharePostArr.post_text + ' </br><a class="truncate_post_url" href="' + this.sharePostArr.sharePostNewsUrl + '" target="_blank">' + this.sharePostArr.sharePostNewsUrl + '</a>';
      } else {
        this.sharePostArr.post_text = this.sharePostArr.post_text + '<a class="truncate_post_url" href="' + this.sharePostArr.sharePostNewsUrl + '" target="_blank">' + this.sharePostArr.sharePostNewsUrl + '</a>';
      }
      this.sharePostArr.post_type = 1;
      this.sharePostArr.post_privacy = this.addPostArr.privacyType;

      this.showHideSharePost = false;
      this._IndexService.addNewsSharePost(this.sharePostArr).subscribe(
        res => {
          this.showHideSharePost = true;
          if (res && res['status_code'] && res['status_code'] == 200) {

            this.toastr.success(res['message'], 'Success!');
            //this.ngOnInit();

          } else {
            this.toastr.error(res['message'], 'Error!');
          }
        });
    } else {
      this.toastr.info("More than 2000 characters are not allowed.")
    }
  }
  //Create Post button(n)

  //Post share model friend list get
  openModalMessengerFriend() {
    this.contactForForwardSearch = '';
    // this.getConnectedUsersListPostTimeline();
    this.contactSearch = '';
    this.selectAllUserOrFans('2');
  }

  getConnectedUsersListPostTimeline() {

    let searchNamePost = {
      search: '',
      page: ''
    }
    this.UserDetailschatForwardLoaderFirstTime = true;
    this.UserchatForwardDetailsLoader = true;
    this.connectchatForwardUserListArr = [];
    this._ChatService.getConnectedUsersListPostTimeline(searchNamePost).subscribe(
      res => {
        this.UserDetailschatForwardLoaderFirstTime = false;
        this.UserchatForwardDetailsLoader = false;

        if (res && res['connect_user_list']) {
          for (let i = 0; i < res['connect_user_list'].length; i++) {
            this.connectchatForwardUserListArr = this.connectchatForwardUserListArr.filter(item => item.id != res['connect_user_list'][i].id);
            this.connectchatForwardUserListArr.push(res['connect_user_list'][i]);
          }
        }

        this.showMorechatForwardUserConnectList = res['showMore'];
        if (res && res['nextPage']) {
          this.nextPagechatForwardConnectUserList = res['nextPage'];
        }

      }, (err) => {
        this.UserDetailschatForwardLoaderFirstTime = false;
        this.UserchatForwardDetailsLoader = false;

        if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
          this.toastr.error(err['error']['message'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        } 
      });
  }

  searchForwarModalUserListPostTimeline($event) {
    this.contactForForwardSearch = $event.target.value;
    let searchNamePost = {
      search: this.contactForForwardSearch,
      page: ''
    }
    this.UserDetailschatForwardLoaderFirstTime = false;
    this.UserchatForwardDetailsLoader = true;

    this._ChatService.getConnectedUsersListPostTimeline(searchNamePost).subscribe(
      res => {
        this.UserDetailschatForwardLoaderFirstTime = false;
        this.UserchatForwardDetailsLoader = false;
        this.connectchatForwardUserListArr = [];

        if (res && res['connect_user_list']) {
          for (let i = 0; i < res['connect_user_list'].length; i++) {
            this.connectchatForwardUserListArr = this.connectchatForwardUserListArr.filter(item => item.id != res['connect_user_list'][i].id);
            this.connectchatForwardUserListArr.push(res['connect_user_list'][i]);
          }
        }

        this.showMorechatForwardUserConnectList = res['showMore'];
        if (res && res['nextPage']) {
          this.nextPagechatForwardConnectUserList = res['nextPage'];
        }

      }, (err) => {
        this.UserDetailschatForwardLoaderFirstTime = false;
        this.UserchatForwardDetailsLoader = false;

        if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
          this.toastr.error(err['error']['message'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        } 
      });
  }

  showMorechatForwardUserListByNamePostTimeline(nextPage) {
    if (nextPage) {
      let searchNamePost = {
        search: this.contactForForwardSearch,
        page: nextPage
      }
      this.UserDetailschatForwardLoaderFirstTime = false;
      this.UserchatForwardDetailsLoader = true;

      this._ChatService.getConnectedUsersListPostTimeline(searchNamePost).subscribe(
        res => {
          this.UserDetailschatForwardLoaderFirstTime = false;
          this.UserchatForwardDetailsLoader = false;

          if (res && res['connect_user_list']) {
            for (let i = 0; i < res['connect_user_list'].length; i++) {
              this.connectchatForwardUserListArr = this.connectchatForwardUserListArr.filter(item => item.id != res['connect_user_list'][i].id);

              this.connectchatForwardUserListArr.push(res['connect_user_list'][i]);
            }
          }

          this.showMorechatForwardUserConnectList = res['showMore'];
          if (res && res['nextPage']) {
            this.nextPagechatForwardConnectUserList = res['nextPage'];
          }

        }, (err) => {
          this.UserDetailschatForwardLoaderFirstTime = false;
          this.UserchatForwardDetailsLoader = false;

          if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
            this.toastr.error(err['error']['message'], 'Error!');
            localStorage.clear();
            sessionStorage.removeItem('fullcomponent');
            this.route.navigate(['/login']);
          } 
        });
    }
  }

  //Create Post button(n)
  CreatePostBtnFrient(sharePostArr, user) {
    if (this.sharePostArr.sharePostText.length >= 0 && this.sharePostArr.sharePostText.length <= 2000) {
      if (this.mediaPostTextTemp && this.mediaPostTextTemp != '') {
        this.sharePostArr.post_text = this.mediaPostTextTemp;
      } else {
        this.sharePostArr.post_text = this.sharePostArr.sharePostText;
      }
      this.sharePostArr.post_text = this.sharePostArr.post_text.replace(/ ?#(\w+)/gi, '<a href="/userSearch/$1"> #$1</a>');
      this.sharePostArr.post_privacy = 3;
      this.sharePostArr.post_share_user_id = user.id;
      this.sharePostArr.post_share_user_type = 1;

      this.sharePostArr.post_text = this.sharePostArr.post_text + ' </br><a class="truncate_post_url" href="' + this.sharePostArr.sharePostNewsUrl + '" target="_blank">' + this.sharePostArr.sharePostNewsUrl + '</a>';
      this.sharePostArr.post_type = 1;

      this.clickedBtn = true;
      this.showHideSharePost = false;
      this._IndexService.addNewsSharePostWithFriend(this.sharePostArr).subscribe(
        res => {
          this.clickedBtn = false;
          this.showHideSharePost = true;
          if (res && res['status_code'] && res['status_code'] == 200) {

            let socketData = {
              contact_user_id: this.sharePostArr.post_share_user_id,
              contact_user_type: 1,
              type: 'postShareByFriend',
            };
            this._UserConnectionService.sendRequestSocket(socketData);

            this.toastr.success(res['message'], 'Success!');
            //this.ngOnInit();

          } else {
            this.toastr.error(res['message'], 'Error!');
          }
        }, (err) => {
          this.clickedBtn = false;
          this.showHideSharePost = true;
        });
    }
  }
  //Create Post button(n)
  // (s)code for follow leaugue/team/players(start)
  openModalFollow(template: TemplateRef<any>, news) {
    this.news_league_id = news.league_id;
    this.tab = 'tab1';
    this.showLeaguesFollowSport();
    //Social media share variable(n) 
    this.clickedBtn = false;
    this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: true, ignoreBackdropClick: true });

    this.showHideSharePostSocialMediaConservative = true;
    this.showHideSharePostSocialMediaTwitter = false;
    this.showHideSharePostSocialMediaFacebook = false;
    this.showHideSharePostSocialMediaLinkedin = false;
    //Social media share variable(n)

    //Post Share Variable(n)
    this.sharePostArr = {};
    this.sharePostArr.media_path = '';
    this.sharePostArr.media_mime_type = '';
    this.showHideSharePost = true;
    this.postButtonHide = true;

    this.sharePostArr.commentShareConservative = 'Conservative';
    this.sharePostArr.commentShareConservativeSection = 'tab1';


    this.sharePostArr.platform_id = this.platform_id;

    if (this.sharePostArr.commentShareConservativeSection == 'tab1') {
      this.sharePostArr.user_type = 1;
      this.sharePostArr.post_privacy = 1;
    } else {
      if (this.sharePostArr.commentShareConservativeSection == 'tab2') {
        this.sharePostArr.user_type = 1;
      } else {
        this.sharePostArr.user_type = 2;
      }
      this.sharePostArr.post_privacy = 2;
    }
    this.sharePostArr.sharePostTextMsg = '';
    this.sharePostArr.sharePostNewsId = news['id'];
    this.sharePostArr.sharePostNewsUrl = news['url'];

    if (news['title']) {
      this.sharePostArr.sharePostText = news['title'].substring(0, 2000);
      let str_title = news['title'];
      this.sharePostArr.sharePostTextShow = (str_title.length > 100) ? str_title.substr(0, 100 - 1) + '...' : str_title;
    } else {
      this.sharePostArr.sharePostText = news['content'].substring(0, 2000);
      let str_title = news['content'];
      this.sharePostArr.sharePostTextShow = (str_title.length > 100) ? str_title.substr(0, 100 - 1) + '...' : str_title;
    }

    if (news['content']) {
      this.sharePostArr.sharePostDescription = news['content'].substring(0, 2000);
      let str_content = news['content'];
      this.sharePostArr.sharePostDescriptionShow = (str_content.length > 150) ? str_content.substr(0, 150 - 1) + '...' : str_content;
      // this.sharePostArr.sharePostDescriptionShow=news['content'].substring(0,100); 
    } else {
      this.sharePostArr.sharePostDescription = '';
      this.sharePostArr.sharePostDescriptionShow = '';
    }

    if (this.sharePostArr.sharePostText == '') {
      this.showHideSharePost = false;
    } else {
      this.urlifyPostOnlyLink(this.sharePostArr.sharePostText);
    }

    if (news['urlToImage']) {
      let fileName = news['urlToImage'];
      let extension = fileName.split('.').pop();

      this.sharePostArr.media_path = news['urlToImage'];
      this.sharePostArr.media_mime_type = 'image/' + extension;
    } else {
      this.sharePostArr.media_path = '';
      this.sharePostArr.media_mime_type = '';
    }

  }


  ///////////////////////list code shraddha (s) ///////////////
  onClick(check) {
    window.scrollTo(0, 0);
    if (check == 1) {
      this.tab = 'tab1';
      this.searchSport = '';
      this.showLeaguesFollowSport();
    } else if (check == 2) {
      this.tab = 'tab2';
      this.searchTeam = '';
      this.showTeamFollowSport();
    } else if (check == 3) {
      this.tab = 'tab3';
      this.searchPlayer = '';
      this.showPlayerFollowSport();
    }


    this.getContactNameArr = [];
    // this.selectedLeagueAllTeams = [];
    // this.selectedLeagueAllPlayers = [];
    // this.selectedTeamAllPlayers = [];
    // this.leagues_ids = [];
    // this.teams_ids = [];
    this.showMore = false;
    this.nextPage = '';
  }

  showLeaguesFollowSport() {
    this.primaryLoaderConatct = true;
    let data = {
      "league_id": this.news_league_id,
      "search": this.searchTeam,
      // "type": "all"
    }
    this._signInsignUp.showLeaguesFollowSport(data).subscribe(
      res => {
        if (res && res['status_code'] == 200) {
          this.getContactNameArr = res['leagues'];
          this.primaryLoaderConatct = false;
          this.leagueListAllTeams = res['leagues'];
          this.leagueListAllPlayers = res['leagues'];
        }
      }, err => {
        console.log(err);
      }
    );
  }
  showMoreLoader: boolean = false;
  showTeamFollowSport() {
    this.getContactNameArr = [];
    let data = {
      "page": "",
      "league_id": this.news_league_id,
      "search": this.searchTeam,
      // "type": "all"
    }
    this.primaryLoaderConatct = true;
    this._signInsignUp.showTeamFollowSport(data).subscribe(
      res => {
        if (res && res['status_code'] == 200) {
          this.primaryLoaderConatct = false;
          for (let i = 0; i < res['teams'].length; i++) {
            this.getContactNameArr.push(res['teams'][i]);
          }
          let uniqueArray = this.removeDuplicates(this.getContactNameArr, 'id');
          this.getContactNameArr = uniqueArray;
          this.showMore = res['showMore'];
          this.nextPage = res['nextPage'];
        }
      }, err => {
        console.log(err);
      }
    );
  }

  showPlayerFollowSport() {
    this.getContactNameArr = [];
    let data = {
      page: "",
      "league_id": this.news_league_id,
      search: this.searchPlayer,
      // type: "all"
    }
    this.primaryLoaderConatct = true;
    this._signInsignUp.showPlayerFollowSport(data).subscribe(
      res => {
        if (res && res['status_code'] == 200) {
          this.primaryLoaderConatct = false;
          for (let i = 0; i < res['players'].length; i++) {
            this.getContactNameArr.push(res['players'][i]);
          }
          let uniqueArray = this.removeDuplicates(this.getContactNameArr, 'id');
          this.getContactNameArr = uniqueArray;
          this.nextPage = res['nextPage'];
          this.showMore = res['showMore'];
        }
      }
    );
  }

  showMoreTeams() {
    // this.route.navigate(['/index']);
    let Data = {
      page: this.nextPage,
      search: this.searchTeam,
      league_id: this.news_league_id,
      //leagues: this.leagues_ids
    }
    this.showMoreLoader = true;
    this._signInsignUp.showTeamFollowSport(Data).subscribe(
      res => {
        if (res && res['status_code'] == 200) {
          this.showMoreLoader = false;
          if (res && res['teams']) {
            for (let i = 0; i < res['teams'].length; i++) {
              this.getContactNameArr.push(res['teams'][i]);
            }

            let uniqueArray = this.removeDuplicates(this.getContactNameArr, "id");
            this.getContactNameArr = uniqueArray;

            this.nextPage = res['nextPage'];
            this.showMore = res['showMore'];
          }
        }
      }, err => {
        console.log(err);
      }
    );
  }

  showMorePlayers() {
    // this.route.navigate(['/index']);
    let Data = {
      page: this.nextPage,
      search: this.searchPlayer,
      league_id: this.news_league_id,
      //   leagues: this.leagues_ids,
      // teams: this.teams_ids
    }
    this.showMoreLoader = true;
    this._signInsignUp.showPlayerFollowSport(Data).subscribe(
      res => {
        if (res && res['status_code'] == 200) {
          this.showMoreLoader = false;
          if (res && res['players']) {
            for (let i = 0; i < res['players'].length; i++) {
              this.getContactNameArr.push(res['players'][i]);
            }

            let uniqueArray = this.removeDuplicates(this.getContactNameArr, "id");
            this.getContactNameArr = uniqueArray;

            this.nextPage = res['nextPage'];
            this.showMore = res['showMore'];
          }
        }
      }, err => {
        console.log(err);
      }
    );
  }

  showMoreSports() {

  }

  //Remove the duplicate entry from the array(D)
  removeDuplicates(originalArray, prop) {
    let newArray = [];
    let lookupObject = {};

    for (let i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (let i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }
  //End Remove the duplicate entry from the array(D)

  //Create Post follow button(s)
  CreatePostBtnFollowSports(sharePostArr, user, key) {
    this.clickedBtn = true;
    // this.getContactNameArr[key].is_follow = false;
    if (this.sharePostArr.sharePostText.length >= 0 && this.sharePostArr.sharePostText.length <= 2000) {
      if (this.mediaPostTextTemp && this.mediaPostTextTemp != '') {
        this.sharePostArr.post_text = this.mediaPostTextTemp;
      } else {
        this.sharePostArr.post_text = this.sharePostArr.sharePostText;
      }
      this.sharePostArr.post_text = this.sharePostArr.post_text.replace(/ ?#(\w+)/gi, '<a href="/userSearch/$1"> #$1</a>');

      this.sharePostArr.post_share_user_id = user.u_id;

      this.sharePostArr.post_text = this.sharePostArr.post_text + ' </br><a class="truncate_post_url" href="' + this.sharePostArr.sharePostNewsUrl + '" target="_blank">' + this.sharePostArr.sharePostNewsUrl + '</a>';
      this.sharePostArr.post_type = 1;

      this.showHideSharePost = false;
      this.clickedBtn = true;
      this.modalRef.hide();
      this._IndexService.addNewsSharePostWithFollowSports(this.sharePostArr).subscribe(
        res => {
          this.showHideSharePost = true;
          this.clickedBtn = false;
          this.getContactNameArr[key].is_follow = true;
          if (res && res['status_code'] && res['status_code'] == 200) {

            let socketData = {
              contact_user_id: this.sharePostArr.post_share_user_id,
              contact_user_type: 1,
              type: 'postShareByFriend',
            };
            this._UserConnectionService.sendRequestSocket(socketData);

            this.toastr.success(res['message'], 'Success', { timeOut: 1000 });
            //this.ngOnInit();

          } else {
            this.toastr.error(res['message'], 'Error!');
          }
        }, (err) => {
          this.clickedBtn = false;
        });
    }
  }
  //Create Post follow button(s)
  decline(): void {
    this.modalRef.hide();
  }
  decline1(): void {
    this.indexNo = '';
    this.lineLoader = false;
    this.modalRefList.hide();
  }
  followId: any;
  unfollow: any;
  connectUserType: any;
  connectUserId: any;
  indexNo: any;
  clicked: boolean = false;
  follow: boolean;
  userName: any;

  followOpenModal(followleague: TemplateRef<any>, user, number) {
    this.follow = false;
    if (user && user['user_id']) {
      this.indexNo = number;
      this.lineLoader = true;
      this.clicked = false;
      this.connectUserType = 1;
      this.connectUserId = user['user_id'];
      this.userName = user['name'];
      this.modalRefList = this.modalService.show(followleague, {
        class: 'modal-sm modal-dialog-centered', backdrop: true,
        ignoreBackdropClick: true
      });
    }
  }

  followConfirm() {
    this.clicked = true;
    this.follow = true;
    if (localStorage.getItem('userProfileType')) {
      let postConnectUser = {
        login_user_type: this.login_user_type,
        connect_user_type: this.connectUserType,
        connect_user_id: this.connectUserId
      }
      this._UserConnectionService.followUserRequeset(postConnectUser).subscribe(
        res => {
          this.modalRefList.hide();
          if (res && res['status_code'] == 200) {
            //push notification start
            const data = {
              user_id: this.connectUserId,
              type: 'Follow'
            }

            this._UserConnectionService.sendPushNotification(data);
            //push notification end

            let socketData = {
              contact_user_id: this.connectUserId,
              type: 'follow',
            };
            this._UserConnectionService.sendRequestSocket(socketData);

            let notificationEmail = {
              to_user_details: res['user_details'],
              from_user_details: res['from_user_details'],
              notification_setting: res['notification_setting']
            }

            this._UserConnectionService.followRequestEmail(notificationEmail).subscribe();

            if (this.follow) {
              for (let i = 0; i < this.getContactNameArr.length; i++) {
                if (this.connectUserId == this.getContactNameArr[i].user_id) {
                  this.getContactNameArr[i]['is_follow'] = res['user_details'][0].is_follow;
                  this.getContactNameArr[i]['follow_id'] = res['user_details'][0].follow_id;
                }
              }
              this.indexNo = '';
              this.lineLoader = false;
              this.modalRefList.hide();
              this.clicked = false;
            }
            this.toastr.success(res['message'], 'Success', { timeOut: 1000 });

          } else {
            if (res && res['status_code'] == 408) {
              this.toastr.info(res['message'], 'Info!');
              this.lineLoader = false;
              this.indexNo = '';
              this.clicked = false;
              this.modalRefList.hide();
            } else {
              this.toastr.error(res['message'], 'Error!');
              this.lineLoader = false;
              this.indexNo = '';
              this.clicked = false;
              this.modalRefList.hide();
            }
          }
        }, err => {
          this.modalRefList.hide();
          if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
            this.toastr.error(err['error']['message'], 'Error!');
            localStorage.clear();
            sessionStorage.removeItem('fullcomponent');
            this.route.navigate(['/login']);
          }
          this.lineLoader = false;
          this.indexNo = '';
          this.modalRefList.hide();
          this.clicked = false;
        }
      );
    } else {
      this.route.navigate(['/index']);
    }
  }


  unfollowOpenModal(unfollowleague: TemplateRef<any>, user, number) {
    this.unfollow = false;
    if (user.follow_id) {
      this.connectUserType = 1;
      this.connectUserId = user['user_id'];
      this.indexNo = number;
      this.lineLoader = true;
      this.clicked = false;
      this.userId = user['user_id'];
      this.userName = user['name'];
      this.followId = user.follow_id
      this.modalRefList = this.modalService.show(unfollowleague, {
        class: 'modal-sm modal-dialog-centered', backdrop: true,
        ignoreBackdropClick: true
      });
    }
  }

  unfollowConfirm() {
    this.clicked = true;
    this.unfollow = true;
    let searchNamePost = {
      "follow_id": this.followId
    }
    this._UserConnectionService.unFollowUser(searchNamePost).subscribe(
      res => {

        if (res && res['status_code'] == 200) {
          if (this.unfollow) {
            for (let i = 0; i < this.getContactNameArr.length; i++) {
              if (this.connectUserId == this.getContactNameArr[i].user_id) {
                this.getContactNameArr[i]['is_follow'] = res['user_details'][0].is_follow;
                this.getContactNameArr[i]['follow_id'] = res['user_details'][0].follow_id;
              }
            }
            this.indexNo = '';
            this.lineLoader = false;
            this.modalRefList.hide();
            this.clicked = false;
          }
          this.toastr.success(res['message'], 'Success', { timeOut: 1000 });
        } else {
          if (res && res['status_code'] == 408) {
            this.toastr.info(res['message'], 'Info!');
            this.lineLoader = false;
            this.indexNo = '';
            this.clicked = false;
            this.modalRefList.hide();
          } else {
            this.toastr.error(res['message'], 'Error!');
            this.lineLoader = false;
            this.indexNo = '';
            this.clicked = false;
            this.modalRefList.hide();
          }
        }
      }, (err) => {
        this.message = 'Confirmed!';
        this.modalRefList.hide();
        if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
          this.toastr.error(err['error']['message'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        } 
        this.lineLoader = false;
        this.indexNo = '';
        this.modalRefList.hide();
      });
  }
  followCancel() {
    this.indexNo = '';
    this.lineLoader = false;
    this.modalRef.hide();
  }
  followCancel1() {
    this.indexNo = '';
    this.lineLoader = false;
    this.modalRefList.hide();
  }
  ///////////////////////list code shraddha (s)  end///////////////

  ////////////shraddha code 26/05/2021////////////
  //pop modal scroll (D)

  //Post URl copy and share URL with pals(n)
  postUrlCopy(post) {
    console.log(post);
    if (post.id) {
      let textarea;
      let result;

      let urlLink = this.project_url + 'news/' + post.title_url;
      try {
        textarea = document.createElement('textarea');
        textarea.setAttribute('readonly', true);
        textarea.setAttribute('contenteditable', true);
        textarea.value = urlLink;

        document.body.appendChild(textarea);

        // textarea.focus();
        textarea.select();

        const range = document.createRange();
        range.selectNodeContents(textarea);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        textarea.setSelectionRange(0, textarea.value.length);
        result = document.execCommand('copy');
      } catch (err) {
        // console.error(err);
        result = null;
      } finally {
        document.body.removeChild(textarea);
      }

      // manual copy fallback using prompt
      if (!result) {
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
        result = prompt(`Press ${copyHotkey}`, urlLink); // eslint-disable-line no-alert
        if (!result) {
          return false;
        }
      }
      this.toastr.success('News copy successfully', 'Success!', { timeOut: 1000 });
      //return true;

    }
  }
  //Post URl copy and share URL with pals(n)

  getConnactUserListSub: any = '';
  user_list_section_type: any = '2';
  contactSearch: any = '';
  UserDetailsLoaderFirstTime: boolean = false;
  UserDetailsLoader: boolean = false;
  connectUserListArr: any = [];
  showMoreUserConnectList: boolean = false;
  nextPageConnectUserList: any = '';
  selectAllUserOrFans(ulst) {
    if (this.getConnactUserListSub) {
      this.getConnactUserListSub.unsubscribe();
    } else {
      this.getConnactUserListSub = '';
    }

    this.user_list_section_type = ulst;

    // let contact_list = document.getElementById("contacts");
    // contact_list.scrollTo(0, 0);
    let searchNamePost = {
      user_list_section_type: this.user_list_section_type,
      search: this.contactSearch,
      page: ''
    }
    this.UserDetailsLoaderFirstTime = true;
    this.UserDetailsLoader = true;
    this.connectUserListArr = [];
    this.getConnactUserListSub = this._ChatService.getConnactUserListForChat(searchNamePost).subscribe(
      res => {
        this.UserDetailsLoaderFirstTime = false;
        this.UserDetailsLoader = false;
        if (res && res['connect_user_list']) {
          for (let i = 0; i < res['connect_user_list'].length; i++) {
            this.connectUserListArr = this.connectUserListArr.filter(item => item.id != res['connect_user_list'][i].id);
            this.connectUserListArr.push(res['connect_user_list'][i]);
          }
        }

        this.showMoreUserConnectList = res['showMore'];
        if (res && res['nextPage']) {
          this.nextPageConnectUserList = res['nextPage'];
        }

      }, (err) => {
        this.UserDetailsLoaderFirstTime = false;
        this.UserDetailsLoader = false;

        if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
          this.toastr.error(err['error']['message'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        }
      });

  }

  //Main Contact list search user(n) 
  contactListSearchFunction(event) {
    this.contactSearch = event.target.value;

    let searchNamePost = {
      user_list_section_type: this.user_list_section_type,
      search: this.contactSearch,
      page: ''
    }
    this.UserDetailsLoaderFirstTime = true;
    this.UserDetailsLoader = true;

    if (this.getConnactUserListSub) {
      this.getConnactUserListSub.unsubscribe();
    } else {
      this.getConnactUserListSub = '';
    }
    this.connectUserListArr = [];
    this.getConnactUserListSub = this._ChatService.getConnactUserListForChat(searchNamePost).subscribe(
      res => {
        this.UserDetailsLoaderFirstTime = false;
        this.UserDetailsLoader = false;
        if (res && res['connect_user_list']) {
          for (let i = 0; i < res['connect_user_list'].length; i++) {
            this.connectUserListArr = this.connectUserListArr.filter(item => item.id != res['connect_user_list'][i].id);
            this.connectUserListArr.push(res['connect_user_list'][i]);
          }
        }

        this.showMoreUserConnectList = res['showMore'];
        if (res && res['nextPage']) {
          this.nextPageConnectUserList = res['nextPage'];
        }

      }, (err) => {
        this.UserDetailsLoaderFirstTime = false;
        this.UserDetailsLoader = false;

        if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
          this.toastr.error(err['error']['message'], 'Error!');
          localStorage.clear();
          sessionStorage.removeItem('fullcomponent');
          this.route.navigate(['/login']);
        }
      });
  }
  //End Main Contact list search user(n) 
  //Click on show more Get user connect list for left bar(n)
  showMoreUserListByName(nextPage) {
    if (nextPage) {
      let searchNamePost = {
        user_list_section_type: this.user_list_section_type,
        search: this.contactSearch,
        page: nextPage
      }
      this.UserDetailsLoaderFirstTime = true;
      this.UserDetailsLoader = true;

      if (this.getConnactUserListSub) {
        this.getConnactUserListSub.unsubscribe();
      } else {
        this.getConnactUserListSub = '';
      }

      this.getConnactUserListSub = this._ChatService.getConnactUserListForChat(searchNamePost).subscribe(
        res => {
          this.UserDetailsLoaderFirstTime = false;
          this.UserDetailsLoader = false;

          if (res && res['connect_user_list']) {
            for (let i = 0; i < res['connect_user_list'].length; i++) {
              this.connectUserListArr = this.connectUserListArr.filter(item => item.id != res['connect_user_list'][i].id);
              this.connectUserListArr.push(res['connect_user_list'][i]);
            }
          }

          this.showMoreUserConnectList = res['showMore'];
          if (res && res['nextPage']) {
            this.nextPageConnectUserList = res['nextPage'];
          }

        }, (err) => {
          this.UserDetailsLoaderFirstTime = false;
          this.UserDetailsLoader = false;

          if (err && err['error'] && err['error']['status_code'] == 401 && err['error']['message']) {
            this.toastr.error(err['error']['message'], 'Error!');
            localStorage.clear();
            sessionStorage.removeItem('fullcomponent');
            this.route.navigate(['/login']);
          }
        });
    }
  }
  //End Click on show more Get user connect list for left bar(n)

  onScroll() {
    if (this.showMoreUserConnectList) {
      this.showMoreUserListByName(this.nextPageConnectUserList);
      this.showMoreUserConnectList = false;
    }

    if (this.showMorechatForwardUserConnectList) {
      this.showMorechatForwardUserListByNamePostTimeline(this.nextPagechatForwardConnectUserList);
    }
    if (this.showMorechatForwardUserConnectList) {
      this.showMorechatForwardUserListByName(this.nextPagechatForwardConnectUserList);
    }
    this.showMorechatForwardUserConnectList = false;
  }
  //pop modal scroll (D)

  ngAfterViewInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.background = this.pals_bg;
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundAttachment = "fixed";
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundSize = "cover";
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundPosition = "center";
  }

}

